import styled from "@emotion/styled";
import { GHOST_BACKGROUND_PRESSED } from "src/constants/colors";
import { Edit05 } from "src/assets/icons";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
`;

export const TableHead = styled.thead`
  background-color: #f2f2f2;
`;

export const TableHeader = styled.th<{ isSelected?: boolean }>`
  padding: 8px;
  border: 1px solid #ddd;
  font-size: 12px;
  text-align: center;
  font-weight: bold;
  background-color: ${(props) =>
    props.isSelected ? GHOST_BACKGROUND_PRESSED : "#f2f2f2"};
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
`;

export const TableCell = styled.td`
  padding: 8px;
  border: 1px solid #ddd;
`;

export const TableCellLink = styled.a``;

export const StyledEditIcon = styled(Edit05)`
  cursor: pointer;
  height: 20px;
  width: 20px;
`;
